/**
 * ArticleComments - blog article comments list and submission form.
 * Custom element: <article-comments>
 *
 * Loading: lazy-loaded by the theme loader (theme.js), which imports this
 * file by its exact name - the filename is load-bearing (import map in
 * snippets/theme-head.liquid).
 * Reconstructed to readable identifiers from the original minified vendor
 * bundle; behaviour verified unchanged by AST alpha-equivalence.
 */
var defineProperty = Object.defineProperty;
var setFunctionName = (target, functionName) => defineProperty(target, "name", {
  value: functionName,
  configurable: !0
});
import { ThemeComponent } from "./theme.js";
import "./vendor.js";
class ArticleComments extends ThemeComponent {}
setFunctionName(ArticleComments, "ArticleComments");
const propertyTypes = {};
ArticleComments.prototype.$name = "ArticleComments";
ArticleComments.prototype.$info = JSON.parse('{"name":"ArticleComments","meta":{"isLegacy":false,"selector":"article-comments"},"props":[],"refs":[]}');
ArticleComments.prototype.$info.component = ArticleComments;
for (const prop of ArticleComments.prototype.$info.props) prop.propertyType = propertyTypes[prop.propertyType];
window.componentService.registerComponent("Article/ArticleComments.ts", {
  ArticleComments: ArticleComments
}, void 0);